import React, {CSSProperties, ReactNode} from 'react'

const xmlns = 'http://www.w3.org/2000/svg'

export interface SvgProps {
  width: number
  height: number
  className?: string
  style?: CSSProperties
  children?: ReactNode | ReactNode[]
}

export const Svg = (props: SvgProps) => {
  const {width, height, children, className, style} = props
  const viewBox = `0 0 ${width} ${height}`
  return (
    <svg
      xmlns={xmlns}
      viewBox={viewBox}
      width={width}
      height={height}
      className={className}
      style={style}
      fill="none"
      stroke="none"
    >
      {children}
    </svg>
  )
}

export const M = (x: number, y: number) => `M ${x} ${y}`

export const m = (dx: number, dy: number) => `m ${dx} ${dy}`

export const h = (dx: number) => `h ${dx}`

export const v = (dy: number) => `v ${dy}`

export const l = (dx: number, dy: number) => `l ${dx} ${dy}`

export const c = (dx: number, dy: number, c: number) =>
  `a ${dx} ${dy} 90 0 ${c} ${dx} ${dy}`
